{
  "title": "Real Estate Tracker",
  "subtitle": "Conectați-vă pentru a continua",
  "username": "Nume de utilizator",
  "password": "Parolă",
  "rememberMe": "Ține-mă minte 30 de zile",
  "signIn": "Conectare",
  "signingIn": "Se conectează...",
  "contactAdmin": "Contactați administratorul pentru acces",
  "validationError": "Numele de utilizator și parola sunt obligatorii",
  "loginFailed": "Autentificare eșuată",
  "loginError": "A apărut o eroare în timpul autentificării",
  "logoutFailed": "Deconectare eșuată",
  "profileUpdateFailed": "Actualizarea profilului a eșuat",
  "passwordChangeFailed": "Schimbarea parolei a eșuat",
  "languageSaveFailed": "Salvarea preferinței de limbă a eșuat",
  "sessionExpired": "Sesiunea a expirat - vă rugăm să vă autentificați din nou"
}
